<template>
  <div class="cancel-container">
    
    <h1>Payment Cancelled</h1>
    <p>Your transaction was not completed. No charges were made.</p>
    <p>If you changed your mind, you can try again below.</p>

    <div class="button-wrapper">
      <router-link to="/products"  data-track="payment_cancelled_return_to_products">
        <button>Return to Purchase Options</button>
      </router-link>

      <router-link to="/analysistool"  data-track="payment_cancelled_return_to_tool">
        <button class="secondary">Go to Main Tool</button>
      </router-link>
    </div>
  </div>
</template>

<style scoped>
.cancel-container {
  max-width: 600px;
  margin: 60px auto;
  padding: 30px;
  text-align: center;
  background: #fefefe;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.cancel-container img {
  width: 64px;
  margin-bottom: 20px;
}

.cancel-container h1 {
  color: #c0392b;
  margin-bottom: 10px;
}

.cancel-container p {
  color: #555;
  margin: 10px 0;
}

.button-wrapper {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
}

button {
  padding: 12px 20px;
  border: none;
  border-radius: 8px;
  background: #6772e5;
  color: white;
  font-size: 16px;
  cursor: pointer;
}

button.secondary {
  background: #bdc3c7;
  color: #2c3e50;
}
</style>
